import React from 'react';

// Types
import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import NumberFormat, { NumberFormatValues } from 'react-number-format';
import { FormControl, FormErrorMessage, Input } from '@wegroup/design-system';
import { prefilledInputComponentStyling } from '../../../../constants/InputComponentStyling';

interface Props {
  question: FlowsQuestion;
}

const MaskedInputComponent: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  const {
    field: { value, onChange, onBlur },
    prefilled,
    error,
  } = useFlowInputComponent({ question });

  return (
    <FormControl isInvalid={!!error}>
      <Input
        variant="flows"
        name={question.id}
        as={NumberFormat}
        format={question.rules.mask}
        value={value}
        onValueChange={(values: NumberFormatValues) => {
          const { formattedValue } = values;
          onChange({ name: question.id, value: formattedValue });
        }}
        onBlur={onBlur}
        mask="_"
        allowEmptyFormatting
        {...(prefilled && { sx: prefilledInputComponentStyling })}
        isDisabled={question.rules.is_disabled}
      />
      <FormErrorMessage>{error?.message}</FormErrorMessage>
    </FormControl>
  );
};

export default MaskedInputComponent;
